import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FullScreenLoading } from "../../../components/loading";
import { Modal } from "../../../components/modal";
import ToolsHeader from "../components/header";
import ToolsSidebar from "./components/sidebar";
import { ToolsBody, ToolsContainer, ToolsWrapper } from "../style";
import ResponsiveFix from "../../../components/responsiveFix";
import {
  ACCOUNT_TITLE,
  ACCOUNT_TITLE_UPLOAD_EXCEL,
  CONTACT,
  COST_CENTER,
  HASHTAG
} from "../../../constants/urls";
import {
  ACCOUNT_TITLE_ICON,
  CONTACT_ICON,
  COST_CENTER_ICON
} from "../../../constants/icons";
import HashtagIcon from "../../../projectSpecificComponents/svgIcons/hashtag";
import { SubItemsSharedAction } from "../../../actions";
import { TEAM_PERMISSIONS } from "../../../constants/teamManagement";
import { checkChangeAccessForToolsItems } from "../../../assets/checkAccess";
import { checkPremiumFeature } from "../../../assets/checkPremium";
import { IMPORT_ACCOUNT_TITLE } from "../../../constants/premiumActions";
import { renderPremiumText } from "../../../assets/renderPremiumIconWithText";
import {
  CONFIRM_ACCEPT_BUTTON_TEXT,
  CONFIRM_REJECT_BUTTON_TEXT
} from "../../../constants/otherTexts";

const CostCenterForm = React.lazy(() =>
  import("../../../containers/tools/costCenter/form")
);
const AccountTitleForm = React.lazy(() =>
  import("../../../containers/tools/accountTitle/form")
);
const HashtagForm = React.lazy(() =>
  import("../../../containers/tools/hashtag/form")
);
const ContactForm = React.lazy(() =>
  import("../../../containers/tools/contact/form")
);

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    const { route } = props;
    let modalComponent,
      modalIcon,
      modalSvgIcon,
      menuBar,
      addPermission,
      itemName;
    if (route.location.pathname.indexOf(COST_CENTER) !== -1) {
      modalComponent = <CostCenterForm closeModal={this.closeModal} />;
      modalIcon = `icon ${COST_CENTER_ICON}`;
      addPermission = TEAM_PERMISSIONS(true).COST_CENTER;
      itemName = "مرکز هزینه";
    } else if (route.location.pathname.indexOf(ACCOUNT_TITLE) !== -1) {
      modalComponent = <AccountTitleForm closeModal={this.closeModal} />;
      modalIcon = `icon ${ACCOUNT_TITLE_ICON}`;
      addPermission = TEAM_PERMISSIONS(true).ACCOUNT_TITLE;
      itemName = "سرفصل‌حساب";
      menuBar = {
        items: [
          { title: "ایجاد", icon: "", onClick: () => this.openModal() },
          {
            title: renderPremiumText("بارگذاری از فایل اکسل", showMessage =>
              checkPremiumFeature(IMPORT_ACCOUNT_TITLE, showMessage)
            ),
            icon: "",
            onClick: () => this.goToUploadExcelPage()
          }
        ]
      };
    } else if (route.location.pathname.indexOf(HASHTAG) !== -1) {
      modalComponent = <HashtagForm closeModal={this.closeModal} />;
      modalSvgIcon = HashtagIcon;
      addPermission = TEAM_PERMISSIONS(true).HASHTAG;
      itemName = "هشتگ";
    } else if (route.location.pathname.indexOf(CONTACT) !== -1) {
      modalComponent = <ContactForm closeModal={this.closeModal} />;
      modalIcon = `icon ${CONTACT_ICON}`;
      addPermission = TEAM_PERMISSIONS(true).CONTACT;
      itemName = "طرف حساب";
    }

    this.state = {
      modalIcon: modalIcon,
      addPermission: addPermission,
      itemName: itemName,
      modalSvgIcon: modalSvgIcon,
      modalComponent: modalComponent,
      menuBar: menuBar
    };
  }

  goToUploadExcelPage() {
    const { history } = this.props;
    const { addPermission, itemName } = this.state;
    checkChangeAccessForToolsItems(addPermission, itemName, () => {
      const showPremiumMessage = checkPremiumFeature(
        IMPORT_ACCOUNT_TITLE,
        true
      );
      if (!showPremiumMessage) {
        history.push(ACCOUNT_TITLE_UPLOAD_EXCEL);
      }
    });
  }
  openModal() {
    const { addPermission, itemName } = this.state;
    checkChangeAccessForToolsItems(addPermission, itemName, () =>
      this.props.toggleSubItemsModal({ show: true })
    );
  }

  closeModal() {
    this.props.toggleSubItemsModal({ show: false, data: null });
  }

  render() {
    const { modalComponent, modalIcon, modalSvgIcon, menuBar } = this.state;
    const { Component, route, subItemsModalInfo } = this.props;
    const Sidebar = (this.props.options && this.props.options.sidebar) || {};
    return (
      <ResponsiveFix>
        <ToolsHeader />
        <ToolsWrapper>
          <ToolsSidebar
            onAddClick={this.openModal}
            addButton={Sidebar.addButton}
            menu={Sidebar.menu}
            SubComponent={Sidebar.subComponent}
            menuBar={menuBar}
          />
          <ToolsBody>
            <ToolsContainer>
              <Suspense fallback={<FullScreenLoading />}>
                <Component route={route} />
              </Suspense>
              {subItemsModalInfo.show && (
                <Modal
                  show={subItemsModalInfo.show}
                  icon={modalIcon}
                  closeHandler={this.closeModal}
                  width="330px"
                  loading={subItemsModalInfo.loading}
                  header={{
                    title: "",
                    icon: modalIcon,
                    SvgIcon: modalSvgIcon,
                    iconColor: "primary_vivid"
                  }}
                  footer={{
                    buttons: [
                      {
                        buttonType: "primary",
                        buttonText: CONFIRM_ACCEPT_BUTTON_TEXT,
                        form: "projectSubItemForm",
                        type: "submit",
                        useLoading: true
                      },
                      {
                        buttonType: "secondary",
                        clickHandler: this.closeModal,
                        buttonText: CONFIRM_REJECT_BUTTON_TEXT
                      }
                    ]
                  }}
                >
                  <Suspense fallback={<FullScreenLoading />}>
                    {modalComponent}
                  </Suspense>
                </Modal>
              )}
            </ToolsContainer>
          </ToolsBody>
        </ToolsWrapper>
      </ResponsiveFix>
    );
  }
}

const mapStateToProps = store => {
  return {
    subItemsModalInfo: store.SubItemsShared.addModalInfo
  };
};
const mapDispatchToProps = dispatch => {
  return {
    toggleSubItemsModal: info =>
      dispatch(SubItemsSharedAction.setAddModalInfo(info))
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Dashboard)
);
